import request from '../common/request.js';

// 获取手机验证码
export function sendCode(data) {
    return request({
        url: '/hualiang/web/user/send',
        method: 'post',
        data
        })
    }
//获取图片验证码
export function randomImage(params) {
    return request({
      url: `${"/hualiang/sys/randomImage/" + params}`,
      method: 'get',
    })
  }
//图片验证码验证
export function verification(data) {
    return request({
      url:"/hualiang/web/user/verification",
      method: 'post',
      data
    })
  }
// 手机号-短信验证码登录
export function phoneNumberLogin(data) {
    return request({
      url:"/hualiang/web/user/phoneLogin",
      method: 'post',
      data
    })
  }
//账号密码登录
export function passwordLogin(data) {
    return request({
      url:"/hualiang/web/user/login",
      method: 'post',
      data
    })
}
// 用户注册
export function userRegister(data) {
  return request({
    url:"/hualiang/web/user/register",
    method: 'post',
    data
  })
}
// 获取用户注册时间-会员到期时间
export function userVipTime() {
  return request({
    url:"/hualiang/web/user/timeDay",
    method: 'post',
  })
}
// 获取vip列表
export function getVipPrice(params) {
  return request({
    url:"/hualiang/web/vipPrice/listPrice",
    method: 'get',
    params
  })
}
// 微信支付接口
export function WxPayCode(data) {
  return request({
    url:"/hualiang/web/wx/scanCode",
    method: 'post',
    data
  })
}
// 支付宝支付接口
export function alPayCode(data) {
  return request({
    url:"/hualiang/web/ali/webPay",
    method: 'post',
    data
  })
}
// 获取订单状态
export function payStatus(params) {
  return request({
    url:"/hualiang/web/orderInfo/isPay",
    method: 'get',
    params,
    headers:{
      "Content-Type": "application/x-www-form-urlencoded",
    }
  })
}
// 获取地图数据
export let mapData =(cityname)=>{
  return server({
      url:cityname+'.json'
  })
}
// 获取用户vip状态
export function getUserVip(data) {
  return request({
    url:"/hualiang/web/vip/getVipList",
    method: 'get',
    data
  })
}
// 统计用户下载数据记录
export function ExportXlsRecord(data) {
    return request({
        url: '/hualiang/web/seeRecord/recordDownload',
        data,
        method: 'post',
    })
}